import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2026 semantics GmbH
//  Purpose   : admin mail dashboard panel
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Table, Loader, Message } from 'semantic-ui-react';
// ---Framework imports
import { XMenu } from 'uix/components';
import { DashSegment } from 'uix/components/grid';
import { useApi, usePersistent } from 'uix/hooks';
// ---Local imports
// ---Globals
export const MailPanel = ({ node })=>{
    let [showFrom, setShowFrom] = usePersistent('showFromColumn', true, 1);
    let { data, error, loading } = useApi('mail/getMailsForNode', {
        otid: node.otid
    }, {
        condition: !!node.otid
    });
    let mails = data?.mails || [];
    if (!error && mails.length == 0) {
        return null;
    }
    let rows = mails.map((mail)=>{
        let time = mail.sendts || mail.insertts;
        return /*#__PURE__*/ _jsxs(Table.Row, {
            negative: mail.deliver_failure,
            children: [
                /*#__PURE__*/ _jsx(Table.Cell, {
                    collapsing: true,
                    children: time
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: mail.hr_state
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: mail.subject
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: mail.to
                }),
                showFrom && /*#__PURE__*/ _jsx(Table.Cell, {
                    children: mail.from
                })
            ]
        }, mail.oeid);
    });
    let menu = /*#__PURE__*/ _jsx(XMenu, {
        size: "small",
        padded: true,
        children: /*#__PURE__*/ _jsx(XMenu.Toggle, {
            icon: "columns",
            content: "From",
            value: showFrom,
            set: setShowFrom,
            title: "Show From column"
        })
    });
    return /*#__PURE__*/ _jsxs(DashSegment, {
        header: "Mails",
        subheader: `${mails.length} Mails`,
        icon: "mail outline",
        loading: loading,
        menu: menu,
        children: [
            error && /*#__PURE__*/ _jsx(Message, {
                negative: true,
                content: error.message || 'Mails konnten nicht geladen werden.'
            }),
            loading && mails.length == 0 ? /*#__PURE__*/ _jsx(Loader, {
                active: true,
                inline: "centered"
            }) : /*#__PURE__*/ _jsxs(Table, {
                compact: "very",
                basic: "very",
                size: "small",
                children: [
                    /*#__PURE__*/ _jsx(Table.Header, {
                        children: /*#__PURE__*/ _jsxs(Table.Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                    children: "Zeit"
                                }),
                                /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                    children: "Subject"
                                }),
                                /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                    children: "To"
                                }),
                                showFrom && /*#__PURE__*/ _jsx(Table.HeaderCell, {
                                    children: "From"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Table.Body, {
                        children: rows
                    })
                ]
            })
        ]
    });
};
